var BACKGROUND_COLORS = {
  brand: 'brand',
  backgroundWhite: 'backgroundWhite',
  backgroundBlue: 'backgroundBlue',
  blue200: 'blue200',
  backgroundDarkBlue: 'backgroundDarkBlue'
};
var FONT_COLORS = {
  textDark: 'textDark',
  textWhite: 'textWhite',
  textMedium: 'textMedium'
};
var ICON_COLORS = {
  brand: 'brand'
};
var DEFAULT_THEME = {};
var BACKGROUND_BLUE_THEME = {
  background: "" + BACKGROUND_COLORS.backgroundBlue,
  fontColor: "" + FONT_COLORS.textDark,
  iconColor: "" + ICON_COLORS.brand
};
var BACKGROUND_BLUE200_THEME = {
  background: "" + BACKGROUND_COLORS.blue200,
  fontColor: "" + FONT_COLORS.textDark,
  iconColor: "" + ICON_COLORS.brand
};
var BACKGROUND_DARKBLUE_THEME = {
  background: "" + BACKGROUND_COLORS.backgroundDarkBlue,
  fontColor: "" + FONT_COLORS.textWhite,
  iconColor: "" + ICON_COLORS.brand
};
var BACKGROUND_WHITE_THEME = {
  background: "" + BACKGROUND_COLORS.backgroundWhite,
  fontColor: "" + FONT_COLORS.textDark,
  iconColor: "" + ICON_COLORS.brand
};
export var AVAILABLE_THEMES = {
  defaultTheme: DEFAULT_THEME,
  backgroundBlue: BACKGROUND_BLUE_THEME,
  blue200: BACKGROUND_BLUE200_THEME,
  backgroundDarkBlue: BACKGROUND_DARKBLUE_THEME,
  backgroundWhite: BACKGROUND_WHITE_THEME
};